<script>
import TemplateMixin from './mixins/TemplateMixin';
import BaseGateway from './mixins/BaseGateway';

export default {
        name: "PaypalGateway",
        mixins: [
            TemplateMixin,
            BaseGateway
        ],        
        computed:{
            gateway(){
                return 'paypal';
            }
        }
}
</script>
